/* 引入解密文件 */
var CryptoJS = require("./aesUtil.js");
var md5 = require("./md5.js");

/* 这两个值必须跟后台一直，前后台必须统一修改！！！ */
var key = CryptoJS.enc.Utf8.parse("7131918159460af4"); //密钥
var iv = CryptoJS.enc.Utf8.parse("8NONwyJtHesysWpM"); //iv

//util的排序函数
function objKeySort(obj) {
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  var newkey = Object.keys(obj).sort();
  //创建一个新的对象，用于存放排好序的键值对
  var newObj = {};
  //遍历newkey数组
  for (var i = 0; i < newkey.length; i++) {
      //向新创建的对象中按照排好的顺序依次增加键值对
      newObj[newkey[i]] = obj[newkey[i]];
  }
  //返回排好序的新对象
  return newObj;
}

export default {
    // 当前时间戳
    nowTime: new Date().getTime(),
    //解密方法
    Decrypt(word) {
        word = CryptoJS.enc.Base64.parse(word).toString();
        var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
        var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
        var decrypt = CryptoJS.AES.decrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
        return decryptedStr.toString();
    },

    //加密方法
    Encrypt(word) {
        var srcs = CryptoJS.enc.Utf8.parse(word);
        var encrypted = CryptoJS.AES.encrypt(srcs, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        let str = encrypted.ciphertext;
        return CryptoJS.enc.Base64.stringify(str);
    },

    /**
     * 生成Token
     */
    productionToken(params) {

        var obj = objKeySort(params);
        // console.log('----',obj)
        var value = "";
        for (var item in obj) {
            if (obj[item] !== false) {
                value += obj[item];
            }
        }
        // console.log(value)
        //加上当前时间戳
        value += this.nowTime;
        //去除所有空格
        // value = value.replace(/\s+/g, "")
        //进行UTF-8编码
        // value = encodeURI(value);
        //进行MD5码加密
        value = md5.hex_md5(value);
        // console.log(value)
        // AES-256-CBC加密
        value = this.Encrypt(value);
        // console.log(value)
        return value;
    }
};
